<template>
    <b-modal :id="modalId" size="lg" hide-footer hide-header>
        <b-card no-body>
            <b-card-header>
                <i class="icon-note"></i>
                <strong>{{ $t('form.create', { item: $t('pdis.pdi') }) }}</strong>
            </b-card-header>
            <b-card-body>
                <Form
                    @onSubmit="onSubmit"
                    @cancel="closeModal"
                    :isEditing="false"
                    v-if="canCreate"
                    :can-create="canCreate"
                    :moduleForm="'pdi'"
                />
                <div v-else>
                    <b-alert show variant="warning" class="mt-3">
                        <i class="fa fa-warning"></i>
                        {{
                            $t('notification.permissions.createDenied', {
                                item: $t('pdis.pdi'),
                            })
                        }}
                    </b-alert>
                </div>
            </b-card-body>
        </b-card>
    </b-modal>
</template>

<script>
import Form from './components/Form'
import i18n from '@/i18n'
import { success, danger } from '@/lib/notification'
import { mapperPdiToAPI } from './mappers/mapperPdiToAPI'
import { getUserPermissions } from '@/services/user-permissions'
import api from '@/services/api'

export default {
    name: 'New',
    components: {
        Form,
    },
    props: {
        userId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            modalId: 'new-pdi-modal',
            permissions: getUserPermissions(),
        }
    },
    computed: {
        canCreate() {
            return this.permissions.modules.has_pdi
        },
    },
    methods: {
        onSubmit(form, onReset, isLoading) {
            if (this.userId !== null && this.userId !== undefined) {
                form.user_id = this.userId
            }
            isLoading(true)
            api.post('/pdis', mapperPdiToAPI(form))
                .then(() => {
                    onReset()
                    this.notificationObjectiveCreatedSuccessfully()
                    this.closeModal()
                    this.$emit('pdiCreated')
                })
                .catch((e) => {
                    console.log(e)
                    this.notificationError()
                })
                .finally(() => {
                    isLoading(false)
                })
        },
        notificationObjectiveCreatedSuccessfully() {
            success(
                i18n.t('notification.createdSuccessfully', {
                    item: i18n.t('pdis.pdi'),
                })
            )
        },
        notificationError() {
            danger()
        },
        closeModal() {
            this.$bvModal.hide(this.modalId)
        },
    },
}
</script>
<style lang="scss" scoped>
::v-deep .modal-body {
    padding: 0 !important;
}
</style>
